import { TUserRole } from '../../types/currentUser';
import { IApplicationState } from '../../types/redux';

const PROFESSIONAL_ROLES: TUserRole[] = ['specialist', 'builder', 'suburbanBuilder'];

export function getIsProfessional(state: IApplicationState) {
  return PROFESSIONAL_ROLES.includes(state.userRole);
}
